import { Component, OnInit, AfterViewInit, ElementRef, ViewChildren, QueryList } from '@angular/core';
import { RestService } from 'src/app/services/rest.service';

@Component({
  standalone: false,
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit, AfterViewInit {
  token: any;
  stats: any[]      = [];
  totalOrders       = 0;
  totalRevenue      = 0;
  avgPerMonth       = 0;
  peakMonth: any    = null;
  maxCount          = 0;
  unauthorized      = false;
  loading           = true;

  @ViewChildren('barEl') barEls!: QueryList<ElementRef>;

  constructor(private rest: RestService) {}

  ngOnInit() {
    this.token = localStorage.getItem('token');
    this.fetchStats();
  }

  ngAfterViewInit() {}

  fetchStats() {
    this.loading = true;
    this.rest.getOrderStats(this.token).subscribe({
      next: (res: any) => {
        this.stats        = res.stats || [];
        this.totalOrders  = res.total_orders  || 0;
        this.totalRevenue = res.total_revenue || 0;
        this.avgPerMonth  = res.avg_per_month || 0;
        this.peakMonth    = res.peak_month    || null;
        this.maxCount     = this.stats.length
          ? Math.max(...this.stats.map((s: any) => s.count))
          : 0;
        this.loading = false;
        // Trigger bar animations after DOM updates
        setTimeout(() => this.animateBars(), 60);
      },
      error: (err) => {
        this.loading = false;
        if (err.status === 403) this.unauthorized = true;
      },
    });
  }

  private animateBars() {
    this.barEls?.forEach((el, i) => {
      setTimeout(() => {
        el.nativeElement.classList.add('bar--risen');
      }, i * 60);
    });
  }

  barPct(count: number): number {
    return this.maxCount > 0 ? (count / this.maxCount) * 100 : 0;
  }
}
